import { Link } from "react-router-dom"
import styled from "styled-components"

export const ProfileWeightChangedNotificationWrapper = styled.div`
  border-radius: 8px;
  background: rgba(255, 200, 0, 0.15);
  display: flex;
  gap: 6px;
  margin-top: 4px;
`

export const WeightChangedNotificationContent = styled.div`
  position: relative;
  padding: 16px;
`

export const IconWrapper = styled.div`
  display: flex;
  width: 34px;
  height: 34px;
  padding: 7px;
  justify-content: center;
  align-items: center;
  border-radius: 16.837px;
  background: var(--Schemes-Primary-Container-Variant, #cceded);
`
export const WeightChangedTitle = styled.h3`
  color: var(--Data_Snacks, #f7ba1e);
  font-size: 14px;
  font-weight: 700;
`

export const WeightChangedText = styled.p`
  margin: 0;
  font-size: 12px;
  color: var(--Schemes-Surface-Container-Lowest, #fff);
`

export const WeightChangedTextStrong = styled.span`
  font-weight: 600;
  color: var(--Schemes-Surface-Container-Lowest, #fff);
`

export const CloseButton = styled.div`
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
`
